import * as yup from 'yup';
import { validationMessagesTranslation } from '../translation';
import { nameSchema, whatsappSchema } from '.';

yup.setLocale(validationMessagesTranslation);

export const createIssue = yup.object().shape({
  user: yup.object().shape({
    name: nameSchema.required(),
    whatsapp: whatsappSchema.required(),
  }),
  message: yup.string().required(),
});
